import { HttpParams } from "@angular/common/http";
import { SortEntry } from "../model/sort-entry";

export class PageDtoParamsMapper {
  static readonly PAGE_PARAM_KEY = "page";
  static readonly SIZE_PARAM_KEY = "size";
  static readonly SORT_PARAM_KEY = "sort";

  static toHttpParams(
    pageNumber: number,
    pageSize: number,
    currentSort: SortEntry[] = [],
    filters: { type: string; value: string }[] = []
  ): HttpParams {
    let params: HttpParams = new HttpParams();
    params = params.set(this.PAGE_PARAM_KEY, pageNumber.toString());
    params = params.set(this.SIZE_PARAM_KEY, pageSize.toString());
    if (currentSort?.length > 0) {
      currentSort.forEach((entry) => {
        params = params.append(this.SORT_PARAM_KEY, `${entry.prop},${entry.dir.toUpperCase()}`);
      });
    }
    if (filters?.length > 0) {
      filters.forEach((filter) => {
        params = params.append(filter.type, filter.value);
      });
    }
    return params;
  }
}
